<template>
  <div class="ai-input-container">
    <div class="ai-input-wrapper" :class="{ focused: isFocused }">
      <textarea
        ref="textarea"
        v-model="text"
        class="ai-textarea"
        placeholder="Pergunte algo para a Nixia..."
        rows="1"
        @keydown.enter.prevent="handleEnter"
        @input="autoResize"
        @focus="isFocused = true"
        @blur="isFocused = false"
      ></textarea>
      <button
        class="ai-send-btn"
        :class="{ active: text.trim().length > 0 }"
        :disabled="!text.trim()"
        @click="submit"
        title="Enviar"
      >
        <i class="fa-solid fa-arrow-up"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AiChatInput",

  data() {
    return {
      text: "",
      isFocused: false,
    };
  },

  methods: {
    handleEnter(e) {
      if (e.shiftKey) return;
      this.submit();
    },

    submit() {
      const msg = this.text.trim();
      if (!msg) return;
      this.$emit("send", msg);
      this.text = "";
      this.$nextTick(() => {
        const ta = this.$refs.textarea;
        if (ta) ta.style.height = "auto";
      });
    },

    autoResize() {
      const ta = this.$refs.textarea;
      if (!ta) return;
      ta.style.height = "auto";
      ta.style.height = Math.min(ta.scrollHeight, 160) + "px";
    },

    focus() {
      this.$refs.textarea?.focus();
    },
  },
};
</script>

<style scoped>
.ai-input-container {
  width: 100%;
}

.ai-input-wrapper {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  background: #ffffff;
  border: 1.5px solid #e2e8f0;
  border-radius: 16px;
  padding: 12px 12px 12px 18px;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.ai-input-wrapper.focused {
  border-color: #94a3b8;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.ai-textarea {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  resize: none;
  font-size: 15px;
  color: #1e293b;
  line-height: 1.5;
  max-height: 160px;
  overflow-y: auto;
  font-family: inherit;
}

.ai-textarea::placeholder {
  color: #94a3b8;
}

.ai-send-btn {
  width: 38px;
  height: 38px;
  flex-shrink: 0;
  border: none;
  border-radius: 50%;
  background: #cbd5e1;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  cursor: not-allowed;
  transition: background 0.2s;
}

.ai-send-btn.active {
  background: #1e293b;
  cursor: pointer;
}

.ai-send-btn.active:hover {
  background: #334155;
}

.dark-theme .ai-input-wrapper {
  background: #2d3748;
  border-color: #4a5568;
}

.dark-theme .ai-input-wrapper.focused {
  border-color: #718096;
}

.dark-theme .ai-textarea {
  color: #e2e8f0;
}

.dark-theme .ai-send-btn.active {
  background: #e2e8f0;
  color: #1e293b;
}
</style>
